module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e816af0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/product/index.vue
// module id = 808
// module chunks = 1